import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44761a58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = { class: "order-info-left" }
const _hoisted_3 = { class: "order-info-status" }
const _hoisted_4 = { class: "info-title" }
const _hoisted_5 = {
  key: 0,
  class: "order-status"
}
const _hoisted_6 = {
  key: 1,
  class: "order-status"
}
const _hoisted_7 = {
  key: 2,
  class: "order-status"
}
const _hoisted_8 = {
  key: 0,
  class: "pay-end-time"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "尊敬的客户，您的订单正在等待付款，请您及时支付订单款项！", -1))
const _hoisted_10 = {
  key: 1,
  class: "tips"
}
const _hoisted_11 = { class: "order-info-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cancel" }, "删除订单", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cancel" }, "再次购买", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cancel" }, "取消订单", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "order-address"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "收货地址及联系方式", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "收货人"),
  /*#__PURE__*/_createTextVNode(": ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "地址"),
  /*#__PURE__*/_createTextVNode(":")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "手机号码: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.orderData.datas.status == 1 ? "等待付款" : "已取消"), 1),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("span", null, [
            _createTextVNode("订单编号: "),
            _createElementVNode("i", null, _toDisplayString(_ctx.orderData.datas.oid), 1)
          ]),
          _createElementVNode("span", null, [
            _createTextVNode("创建时间: "),
            _createElementVNode("i", null, _toDisplayString(_ctx.orderData.datas.create_time), 1)
          ]),
          _createElementVNode("span", null, [
            _createTextVNode("状态: "),
            (_ctx.orderData.datas.status == 1)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5, "等待付款..."))
              : _createCommentVNode("", true),
            (_ctx.orderData.datas.status == 3)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6, "已取消"))
              : _createCommentVNode("", true),
            (_ctx.orderData.datas.status == 5)
              ? (_openBlock(), _createElementBlock("i", _hoisted_7, "已退款"))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.orderData.datas.status == 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, [
                _createTextVNode("剩余时间:"),
                _createVNode(_component_CountDown, {
                  onUpdateOrderSendStatus: _ctx.updateOrderSendStatus,
                  totaltime: 
                _ctx.getTime(
                  _ctx.orderData.datas.forRrestOf
                    ? _ctx.orderData.datas.forRrestOf
                    : '1665387853'
                )
              
                }, null, 8, ["onUpdateOrderSendStatus", "totaltime"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.orderData.datas.address && _ctx.orderData.datas.if_invoicing == '0')
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 提示：该订单包含加密狗，需要邮寄 "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.orderData.datas.status == 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "order-info-cancel order-info-delete",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateOrderStatus(4)))
            }, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.orderData.datas.status == 3 || _ctx.orderData.datas.status == 5)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "order-info-cancel",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBuy && _ctx.goBuy(...args)))
            }, _hoisted_15))
          : _createCommentVNode("", true),
        (
            _ctx.orderData.datas.status == 1 &&
            (_ctx.counterStore.pid == 0 || _ctx.orderData.datas.uid == _ctx.counterStore.id)
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "order-info-cancel",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateOrderStatus(3)))
            }, _hoisted_17))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.orderData.datas.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("p", null, [
            _hoisted_20,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderData.datas.address.contacts), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_21,
            _createElementVNode("span", null, _toDisplayString(_ctx.orderData.datas.address.province) + " " + _toDisplayString(_ctx.orderData.datas.address.city) + " " + _toDisplayString(_ctx.orderData.datas.address.area) + " " + _toDisplayString(_ctx.orderData.datas.address.address), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_22,
            _createElementVNode("span", null, _toDisplayString(_ctx.showMobile(_ctx.orderData.datas.address.phonenumber)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}